import useInfiniteScrollApolloQuery from '@hooks/useInfiniteScroll/useInfiniteScrollApolloQuery';
import DesignerBoardsQuery, { IDesignerBoard, DEFAULT_PAGE_SIZE } from '@components/pages/DesignerProfile/graphql/designer-boards.graphql';
import { useEffect, useState } from 'react';

export default function useDesignerBoards(
  designerId: string,
  includeHidden: boolean = false,
  initialBoards: IDesignerBoard[] = []
) {
  const {
    data,
    error,
    loading,
    loadingMore,
    reset,
    resetting,
  } = useInfiniteScrollApolloQuery({
    query: DesignerBoardsQuery,
    variables: {
      designerId,
      includeHidden,
    },
    dataResultsKey: 'designerPublicBoards',
    targetScrollOffset: 2400,
  }, {
    pageSize: DEFAULT_PAGE_SIZE,
  });

  const [boards, setBoards] = useState(initialBoards);

  useEffect(() => {
    if (data && data.designerPublicBoards && data.designerPublicBoards.items) {
      setBoards(data.designerPublicBoards.items);
    }
  }, [data]);

  return {
    boards,
    error,
    loading: loading && initialBoards.length === 0,
    loadingMore,
    reset,
    resetting,
  };
}
